module.exports = __webpack_public_path__ + "static/media/luoshan_web.0ecbc690.webp";